import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    overflow: "hidden",
    ["--tb" as any]: "64px"
  },
  mainContent: {
    display: "flex",
    flex: 1
  },
  leftContent: {
    flex: 1,
    padding: "16px",
    backgroundColor: "#EFEFEF",
    overflow: "hidden",
    boxSizing: "border-box"
  },
  leftContentBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    minHeight: "calc(100svh - var(--tb))"
  },
  rightImageContainer: {
    flex: 1,
    position: "relative",
    width: "100%",
    height: "100%",
    overflow: "hidden"
  },
  rightImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover"
  }
};
